import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

import { AvaliacaoEstrelas } from "../avaliacaoestrelas/AvaliacaoEstrelas";
import { ILojaPublica } from "shared/interfaces/ILojaPublica";
import { buscarLojas } from "shared/services/api/lojas.api";

import styles from "./LojasEncontradas.module.scss";

interface LojasEncontradasProps {
  termo: string;
}

/**
 * Lojas cujo nome casa com a busca, acima da lista de produtos.
 * Não aparece enquanto carrega, sem resultados ou se a busca falhar.
 */
export const LojasEncontradas: React.FC<LojasEncontradasProps> = ({
  termo,
}) => {
  const [lojas, setLojas] = useState<ILojaPublica[]>([]);

  useEffect(() => {
    let ativo = true;

    setLojas([]);

    buscarLojas(termo)
      .then((resultado) => {
        if (ativo) setLojas(resultado);
      })
      .catch(() => {
        if (ativo) setLojas([]);
      });

    return () => {
      ativo = false;
    };
  }, [termo]);

  if (lojas.length === 0) {
    return null;
  }

  return (
    <section className={styles.container}>
      <h3 className={styles.titulo}>Lojas</h3>

      <div className={styles.lista}>
        {lojas.map((loja) => (
          <Link
            key={loja.id}
            to={`/lojas/${loja.id}`}
            className={styles.card}
          >
            <img
              src={loja.logo || "/imagens/semloja.png"}
              alt={`Logo ${loja.nome}`}
              className={styles.logo}
              onError={(e) => {
                e.currentTarget.src = "/imagens/semloja.png";
              }}
            />

            <div className={styles.info}>
              <strong className={styles.nome}>{loja.nome}</strong>

              {loja.avaliacao.media === null ? (
                <span className={styles.semAvaliacao}>
                  Sem avaliações
                </span>
              ) : (
                <AvaliacaoEstrelas
                  rating={loja.avaliacao.media}
                  total={loja.avaliacao.total}
                  size={12}
                />
              )}

              {loja.endereco.cidade && (
                <span className={styles.local}>
                  <MapPin size={12} />
                  {loja.endereco.cidade}/{loja.endereco.estado}
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
